import React, { useState } from 'react';
import { Alert, Button, Card, CardContent, Container, Stack, TextField, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAdminAuth } from '../../context/AdminAuthContext';

export function AdminLoginPage() {
  const { login } = useAdminAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState('admin');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  return (
    <Container maxWidth="sm" sx={{ py: 6 }}>
      <Card>
        <CardContent>
          <Stack spacing={2}>
            <Typography variant="h4">Admin prijava</Typography>
            <TextField fullWidth label="Korisničko ime" value={username} onChange={(event) => setUsername(event.target.value)} />
            <TextField fullWidth type="password" label="Lozinka" value={password} onChange={(event) => setPassword(event.target.value)} />
            {error && <Alert severity="error">{error}</Alert>}
            <Button variant="contained" onClick={async () => {
              try {
                setError('');
                await login(username, password);
                navigate('/admin/dashboard', { replace: true });
              } catch (loginError) {
                setError(loginError.message);
              }
            }}>Prijavi se</Button>
          </Stack>
        </CardContent>
      </Card>
    </Container>
  );
}
